import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { perfilService } from '../services/PerfilService';
import { UsuarioPerfil } from '../types/enums/UsuarioPerfil';

interface UseMenusPermitidosResult {
  menusPermitidos: string[];
  loading: boolean;
  temPermissaoMenu: (codigoTela: string) => boolean;
}

/**
 * Hook para buscar os menus permitidos para o usuário atual
 * O backend é responsável por retornar a lista de menus baseado no perfil do usuário
 */
export const useMenusPermitidos = (): UseMenusPermitidosResult => {
  const { user } = useAuth();
  const [menusPermitidos, setMenusPermitidos] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const carregarMenus = async () => {
      if (!user?.guid) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        if (user.role.toLocaleLowerCase() !== UsuarioPerfil.THINKWAY_ADMIN.toLocaleLowerCase() &&
            user.role.toLocaleLowerCase() !== UsuarioPerfil.OWNER.toLocaleLowerCase() &&
            user.role.toLocaleLowerCase() !== UsuarioPerfil.EMPRESA_ADMIN.toLocaleLowerCase()) {
            const menus = await perfilService.buscarMenusPermitidos();
          setMenusPermitidos(menus);
        }
      } catch (error) {
        console.error('Erro ao carregar menus permitidos:', error);
        setMenusPermitidos([]);
      } finally {
        setLoading(false);
      }
    };

    carregarMenus();
  }, [user]);

  const temPermissaoMenu = (codigoTela: string): boolean => {
    if (!user?.guid) {
      console.log('useMenusPermitidos.temPermissaoMenu: Sem usuário logado');
      return false;
    }
    
    // Admins sempre têm acesso
    if (user.role.toLocaleLowerCase() === UsuarioPerfil.THINKWAY_ADMIN.toLocaleLowerCase() || user.role.toLocaleLowerCase() === UsuarioPerfil.OWNER.toLocaleLowerCase()) {
      return true;
    }
    
    // Empresa Admin não tem acesso a perfis e configurações do sistema
    if (user.role.toLocaleLowerCase() === UsuarioPerfil.EMPRESA_ADMIN.toLocaleLowerCase()) {
      return codigoTela !== 'perfis' && codigoTela !== 'configuracoes-usuario';
    }
    
    // Para outros, verificar na lista
    const hasAccess = menusPermitidos.includes(codigoTela);
    console.log(`useMenusPermitidos.temPermissaoMenu: Verificando na lista de menus - acesso=${hasAccess}`);
    return hasAccess;
  };

  return {
    menusPermitidos,
    loading,
    temPermissaoMenu
  };
};
